import axiosInstance from "../services/axiosInstance";

export const verifyInvitationToken = async (token) => {
  try {
    const response = await axiosInstance.get(
      `../verify/invitation?token=${encodeURIComponent(token)}`,
    );

    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: 500,
        message: "An error occurred while verifying invitation.",
      }
    );
  }
};
